import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import './Statement.scss';

/**
 * An oversized brand moment. Used to break rhythm between dense sections.
 * `lines` may contain a { accent: true } marker to tint a line.
 */
const Statement = ({ lines, note, align = 'left', size = 'lg', id }) => {
    const [ref, revealed] = useReveal({ threshold: 0.3 });

    return (
        <section
            ref={ref}
            id={id}
            className={`statement is-${align} is-${size} ${revealed ? 'is-in' : ''}`}
        >
            <div className="statement-inner">
                <h2 className="statement-lines">
                    {lines.map((line, i) => {
                        const text = typeof line === 'string' ? line : line.text;
                        const accent = typeof line === 'object' && line.accent;
                        return (
                            <span className="statement-line" key={text}>
                                <span
                                    className={`statement-line-in ${accent ? 'is-accent' : ''}`}
                                    style={{ '--i': i }}
                                >
                                    {text}
                                </span>
                            </span>
                        );
                    })}
                </h2>
                {note && <p className="statement-note">{note}</p>}
            </div>
        </section>
    );
};

export default Statement;
